export enum ExcludedFileTypes {
  XML = "XML",
  PACKAGE_1 = "Package1",
  PACKAGE_2 = "Package2",
  PACKAGE_3 = "Package3",
}
